import Button from '@/components/Buttons/Button';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { closeDrawer } from '@/slices/drawerSlice';

export const ExportDrawerCancelButton = () => {
  const dispatch = useAppDispatch();

  return (
    <Button
      sx={{
        color: 'primary.main',
        borderColor: 'primary.main'
      }}
      variant='outlined'
      onClick={() => {
        dispatch(closeDrawer());
      }}
    >
      Cancel
    </Button>
  );
};
